import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization } = {}) => jwt || Authorization || "";

const permissionController = {
  getAllPermission: ({ Authorization, jwt } = {}) =>
    Utils.controller(
      "api/permissions/v1/getAllPermission",
      "",
      "GET",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    ),
};

export default permissionController;
